import { useMutation } from '@tanstack/react-query'
import { updatePendingAgreements } from 'services/AgreementsService'

export const usePendingAgreementsMutation = () => {
  return useMutation({ mutationFn: updatePendingAgreements })
}
